<template>
  <div :class="col" class="vb-card-pax mt-3">

    <p class="vb-card-pax__title">{{ traveler_label }}</p>
    <ul class="vb-card-pax__list">
      <li v-if="full_name">Nome e cognome:<strong class="semibold">{{ full_name }}</strong></li>
      <li v-if="formatted_birthday">Data di nascita:<strong class="semibold">{{ formatted_birthday }}</strong></li>
      <li v-if="passenger_info.nationality">Nazionalità:<strong class="semibold">{{ passenger_info.nationality }}</strong></li>
      <li v-if="passenger_info.prefix_phone && passenger_info.phone">Cellulare:<strong class="semibold">+{{ passenger_info.prefix_phone }} {{ passenger_info.phone }}</strong></li>
    </ul>

  </div>

</template>

<script>
import moment from 'moment'
import {
  get_pax_field,
  type_pax_options,
} from '@resources/passenger'
import { passenger_to_flat } from '@alpitour/utilities/passenger'

const options_to_map = (options) => options.reduce((acc, { value, text }) => {
  if (value) { acc[value] = text }
  return acc
}, {})

const pax_type_labels = options_to_map(type_pax_options)

export default {
  name: 'card-pax',

  props: {
    pax: Object,
    // 1 based index, 0 means unset
    index: {
      type: Number,
      default: 0,
    },
    col: {
      type: String,
      default: '',
    },
  },

  computed: {
    passenger_info() {
      if (this.pax.details && this.pax.details.fields) {
        const raw = passenger_to_flat(this.pax)
        const info = {}
        Object.keys(raw).forEach(key => {
          info[get_pax_field(key)] = raw[key]
        })
        // passenger_to_flat skips type_pax (internal), but the card needs it
        const type_field = this.pax.details.fields.find(f => get_pax_field(f.name) === 'type_pax')
        if (type_field && type_field.value) {
          info.type_pax = type_field.value
        }
        return info
      }
      // Already flat — canonicalize keys
      const info = {}
      Object.keys(this.pax).forEach(key => {
        if (this.pax[key] !== undefined && this.pax[key] !== null) {
          info[get_pax_field(key)] = this.pax[key]
        }
      })
      return info
    },
    full_name() {
      return `${this.passenger_info.name || ''} ${this.passenger_info.surname || ''}`.trim()
    },
    traveler_label() {
      const age_label = (pax_type_labels[this.passenger_info.type_pax] || 'ADULTO').toLowerCase()
      if (!this.pax.id && this.index <= 0) {
        return `Viaggiatore (${age_label})`
      }
      return `Viaggiatore ${this.pax.id || this.index} (${age_label})`
    },
    formatted_birthday() {
      if (!this.passenger_info.birthday) { return '' }
      return moment(this.passenger_info.birthday).format('DD-MM-YYYY')
    },
  },
}
</script>

<style lang="scss" scoped>

  .vb-card-pax {

    &__title {
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
      color: $dark;
      position: relative;
      padding-left: $grid-gutter-width/2;
      margin-bottom: $grid-gutter-width/4;

      &:before {
        content: "";
        width: $grid-gutter-width/5;
        background-color: var(--secondary);
        position: absolute;
        top: 3px;
        bottom: 3px;
        left: 0;
        border-radius: $border-radius;
      }
    }

    &__list {
      list-style: none;
      padding-left: 0;
      margin-bottom: 0;
      font-size: $font-size-md;

      li {
        margin-bottom: $grid-gutter-width/6;

        strong {
          padding-left: $grid-gutter-width/3;
        }
      }
    }
  }

</style>
